import React, { FC } from "react";
import MaterialSnackbar, { SnackbarProps } from "@mui/material/Snackbar";

export const Snackbar: FC<SnackbarProps & any> = React.forwardRef((props, ref) => (
  <MaterialSnackbar {...props} ref={ref} />
));
